import { useMemo } from "react";
import { INode, Graph, ImageNode } from "@noli/core";
import { useSelecting } from "@noli/business";

type AllImageSelectableTypes = "image" | "group" | "multiple";

const ALL_IMAGE_SELECTABLE_TYPES = ["image", "group", "multiple"];
const nodesKey: Record<AllImageSelectableTypes, "nodes" | "displayNode"> = {
  multiple: "nodes",
  image: "displayNode",
  group: "displayNode",
};

export interface SelectImagesType {
  imageNodes: ImageNode[];
  originNodes: INode[];
  originImageNodes: ImageNode[];
}

interface UseSelectImgsOptions {
  selectType?: AllImageSelectableTypes[];
  maxCount?: number;
}
export function useSelectImages(options?: UseSelectImgsOptions): SelectImagesType {
  const { selectType = ALL_IMAGE_SELECTABLE_TYPES, maxCount } = options ?? {};
  const selected = useSelecting("raw");
  const nodes = useMemo(() => {
    if (selected && selectType.includes(selected.type)) {
      const nodes = selected[nodesKey[selected.type as AllImageSelectableTypes]];
      if (nodes) {
        return (
          Array.isArray(nodes) ? nodes.map((node) => node.snapshot()) : [nodes.snapshot()]
        ) as INode[];
      }
    }
    return [];
  }, [selected]);

  const result = useMemo(() => {
    const selectedImageResult: SelectImagesType = {
      imageNodes: [],
      originNodes: [],
      originImageNodes: [],
    };

    if (nodes?.length) {
      const _nodes = Graph.fromNodes(nodes).allSingleNodes;
      const imageTypeNodes = _nodes.filter((node) => {
        return node.type === "image";
      }) as ImageNode[];

      selectedImageResult.originNodes = nodes;
      selectedImageResult.originImageNodes = imageTypeNodes;

      if (imageTypeNodes.length > 0) {
        if (!maxCount) {
          selectedImageResult.imageNodes = imageTypeNodes;
        } else if (maxCount && imageTypeNodes.length <= maxCount) {
          selectedImageResult.imageNodes = imageTypeNodes;
        }
      }
      return selectedImageResult;
    }

    return selectedImageResult;
  }, [nodes]);

  return result;
}
